import { Minus, Plus } from "lucide-react";

export default function CalcStepper({ label, hint, value, min, max, onChange, testId }) {
  return (
    <div className="flex items-center justify-between gap-4 py-3 border-b border-[var(--border)]">
      <div>
        <div className="font-semibold text-[var(--heading)]">{label}</div>
        <div className="text-xs text-[var(--muted)] mt-0.5">{hint}</div>
      </div>
      <div className="flex items-center gap-2 shrink-0">
        <button
          type="button"
          onClick={() => onChange(Math.max(min, value - 1))}
          disabled={value <= min}
          className="w-11 h-11 rounded-full border border-[var(--border)] bg-white flex items-center justify-center disabled:opacity-30"
          data-testid={`${testId}-minus`}
          aria-label={`${label} csökkentés`}
        >
          <Minus className="w-4 h-4" />
        </button>
        <span className="w-8 text-center font-heading text-xl" data-testid={`${testId}-value`}>
          {value}
        </span>
        <button
          type="button"
          onClick={() => onChange(Math.min(max, value + 1))}
          disabled={value >= max}
          className="w-11 h-11 rounded-full border border-[var(--border)] bg-white flex items-center justify-center disabled:opacity-30"
          data-testid={`${testId}-plus`}
          aria-label={`${label} növelés`}
        >
          <Plus className="w-4 h-4" />
        </button>
      </div>
    </div>
  );
}
